export const kyLocale = {
  'common.buttons.submit': 'Submit',
  'common.buttons.confirm': 'Confirm',
  'common.buttons.save': 'Save',
  'common.buttons.edit': 'Edit',
  'common.buttons.delete': 'Delete',
  'common.buttons.cancel': 'Cancel',
  'common.buttons.close': 'Close',
  'common.buttons.back': 'Back',
  'common.buttons.continue': 'Continue',
  'common.buttons.add': 'Add',
  'common.buttons.skip': 'Skip',
  'common.buttons.done': 'Done',

  'common.validation.isRequired': 'Field "{name}" is required',
  'common.validation.minLength': 'Minimum length: {length}',
  'common.validation.maxLength': 'Maximum length: {length}',
};
